import React from 'react';
import Header4 from './../Common/Header4';
import Footer from './../Common/Footer';
import Banner from './../Elements/Banner';

var bnrimg = require('./../../images/banner/9.jpg');

class TeamDetail extends React.Component {
    render() {
        return (
            <>
                <Header4 />
                <div className="page-content">
                    <Banner title="CEO De la société ACE" pagename=" Detail" description="" bgimage={bnrimg} />
                    {/* ABOUT TEAM MEMBER SECTION START */}
                    <div className="section-full p-tb80 bg-white mobile-page-padding">
                        <div className="container">
                            <div className="section-content ">
                                <div className="about-team-member text-black">
                                    <div className="row">
                                        <div className="col-lg-4 col-md-5 col-sm-12">
                                            <div className="about-single-team-info-left p-a30 sx-bg-secondry">
                                                <div className="profile-image">
                                                    <img src={require('./../../images/Adem.jpeg')} alt="" />
                                                </div>
                                                <div className="text-black bg-white p-a30">
                                                    <h4 className="m-t0">Adem Jlel</h4>
                                                    <h5 className="m-b0">CEO chez ACE</h5>
                                                </div>
                                                <div className="team-single-social m-t30 text-white">
                                                    <ul className="m-b0 list-unstyled">
                                                        <li><span><i className="fa fa-envelope" /></span><span>Jleladem@gmail.com</span></li>
                                                        <li><span><i className="fa fa-phone" /></span><span>(+216) 95 411 127 </span></li>
                                                        <li><span><i className="fa fa-map-marker" /></span><span>Kairouan ,Tunisie </span></li>
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-8 col-md-7 col-sm-12">
                                            <div className="about-single-team-info">
                                                <div className="our-exp p-b30">
                                                    <div className="sx-box">
                                                        <h3 className="sx-text-primary"> Ingénieur en génie civil </h3>
                                                    </div>
                                                    
                                                </div>
                                                {/* TITLE START */}
                                                <div className="section-head">
                                                    <div className="sx-separator-outer separator-left">
                                                        
                                                    </div>
                                                </div>
                                                {/* TITLE END */}
                                                <div className="experience">
                                                    <div className="sx-box our-story">
                                                        
                                                        <div className="our-story-detail">
                                                            <p>Adem Jlel est un ingénieur conseil agrée aen génie civil depuis 2018, ayant entamé sa carrière chez Heni Construction, une entreprise tunisienne spécialisée dans les travaux de gros œuvre.<br/> Il y a exercé en tant  qu'ingénieur/pilote de chantier, avant de rejoindre Carthage2CE en tant qu'ingénieur chargé d'études en génie civil. Carthage2CE, un bureau d'études franco-tunisien, se distingue par ses projets d'envergure en Tunisie, en France et en Afrique. <br/> Adem a progressé au sein de cette structure pour occuper le poste de responsable de production, démontrant ainsi ses compétences et son expertise dans le domaine du génie civil à travers une diversité de projets internationaux et nationaux.</p>
                                                        </div>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* ABOUT TEAM MEMBER SECTION END */}
                </div>

                <Footer />
            </>
        );
    };
};

export default TeamDetail;

/*<span className="progressText "><b>Architecher</b></span>
                                                    <div className="progress m-b30 m-t10">
                                                        <div className="progress-bar sx-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '95%' }} aria-valuenow={95} aria-valuemin={0} aria-valuemax={100}>95%</div>
                                                    </div>
                                                    <span className="progressText "><b>Construction</b></span>
                                                    <div className="progress m-b30 m-t10">
                                                        <div className="progress-bar sx-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '85%' }} aria-valuenow={85} aria-valuemin={0} aria-valuemax={100}>85%</div>
                                                    </div>
                                                    <span className="progressText "><b>Interior</b></span>
                                                    <div className="progress m-b30 m-t10">
                                                        <div className="progress-bar sx-bg-primary progress-bar-striped progress-bar-animated text-black" role="progressbar" style={{ width: '65%' }} aria-valuenow={65} aria-valuemin={0} aria-valuemax={100}>65%</div>*/